import React, { useContext } from 'react';
import { isMobile } from 'react-device-detect';
import { makeStyles } from '@material-ui/core/styles';
import { AppContext } from 'contexts';

const useStyles = makeStyles({
  roomInfo: {
    position: 'absolute',
    left: '50%',
    transform: 'translateX(-50%)',
    color: 'white',
    fontSize: '20px',
    padding: '2px 10px',
    whiteSpace: 'nowrap',
    pointerEvents: 'none',

    '@media (min-width: 768px)': {
      bottom: 10,
    },

    '@media (max-width: 767px)': {
      top: 120,
    },

    '& span': {
      padding: '2px 10px 2px 10px',
      backgroundColor: 'rgba(0, 0, 0, 0.3)',
      borderRadius: '10px',
    },
  },
});

function RoomInfo() {
  const classes = useStyles();
  const appContext = useContext(AppContext);

  const { currentRoom, floorPlanZoom, listing } = appContext;

  if (!currentRoom || (isMobile && floorPlanZoom)) return null;

  const invalidRoomMeasurement =
    currentRoom.width === 10 &&
    currentRoom.width_inches === 0 &&
    currentRoom.height === 10 &&
    currentRoom.height_inches === 0;

  const infos = [currentRoom.roomname];
  if (
    !currentRoom.isHideMeasurements &&
    (currentRoom.width || currentRoom.width_inches) &&
    (currentRoom.height || currentRoom.height_inches) &&
    !invalidRoomMeasurement &&
    listing.show_measures
  ) {
    infos.push(`${currentRoom.width}′${currentRoom.width_inches}″`);
    infos.push('X');
    infos.push(`${currentRoom.height}′${currentRoom.height_inches}″`);
  }

  return (
    <div className={classes.roomInfo}>
      <span>{infos.join(' ')}</span>
    </div>
  );
}

export default RoomInfo;
